import React from 'react';

const LinkIcon = () => {
  return (
    <svg
      stroke='currentColor'
      fill='transparent'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      className='icons'
      height='20'
      width='20'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1'
      ></path>
    </svg>
  );
};

export default LinkIcon;
